export default __webpack_public_path__ + "static/media/rectangleFasting.16d1a1fe.svg";